var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locationWrap"},[_c('h1',{staticClass:"title"},[_vm._v("LOCATION")]),_vm._v(" "),_c('h4',{staticClass:"buildingName"},[_vm._v(_vm._s(_vm.location.buildingName))]),_vm._v(" "),_c('strong',{staticClass:"companyAddress"},[_vm._v(_vm._s(_vm.location.address))]),_vm._v(" "),_c('naver-map')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0127ac0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Sunnyfactory/Location.vue
// module id = null
// module chunks = 